import React, { useContext } from 'react';

import TestimonialContext from '~/App/Modules/Testimonials/Context/TestimonialContext';
import OutroPage from '~/App/Modules/Testimonials/Components/OutroMessage';
import useAnalytics from '~/react-hooks/use-analytics';
import { TESTIMONIAL_RESPONSE_GET_STARTED } from '~/generated/AnalyticsTypes';
import { defaultTestimonialText } from '~/App/Modules/Testimonials/Pages/Editor/constants';
import {
  addUtmToLink,
  UTM_CAMPAIGN_TESTIMONIALS_PLG,
  UTM_MEDIUM_THANK_YOU_BANNER,
  UTM_SOURCE_TESTIMONIAL_REQUEST_PAGE,
} from '~/utils/add-utm-to-link';
import { getRichTextFromSlateData } from '@vimily/bonjoro-ui-components-v2/RichTextEditor';
import { computeTextColor } from '@vimily/bonjoro-ui-components-v2';

export default function OutroPageContainer() {
  const { text, landing_page, user, metadata } = useContext(TestimonialContext);
  const logoUrl = landing_page.logo?.url ?? '';
  const analytics = useAnalytics();

  const { outro, font_family } = metadata?.style ?? {};

  const handleButtonClick = () => {
    void analytics.track(TESTIMONIAL_RESPONSE_GET_STARTED, {
      project_owner: user.email,
    });

    // redirect to testimonial landing page
    window.location.href = addUtmToLink(
      'https://www.bonjoro.com/testimonials',
      {
        utm_source: UTM_SOURCE_TESTIMONIAL_REQUEST_PAGE,
        utm_medium: UTM_MEDIUM_THANK_YOU_BANNER,
        utm_campaign: UTM_CAMPAIGN_TESTIMONIALS_PLG,
      }
    );
  };

  return (
    <OutroPage
      message={getRichTextFromSlateData(
        text.outro_rich ?? defaultTestimonialText.outro_rich
      )}
      className='max-w-[818px] min-h-[350px] text-2xl'
      onButtonClick={handleButtonClick}
      logoUrl={logoUrl}
      bgColor={outro?.box_color}
      fontFamily={font_family}
      fontColor={computeTextColor(outro?.box_color)}
    />
  );
}
